import React from "react";

export default function FilterIcon({ active }: any)
{
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 15.75C13.9125 15.75 14.25 15.4125 14.25 15V11.25H12.75V15C12.75 15.4125 13.0875 15.75 13.5 15.75ZM4.5 15.75C4.9125 15.75 5.25 15.4125 5.25 15V8.25H3.75L3.75 15C3.75 15.4125 4.0875 15.75 4.5 15.75ZM15 8.25H14.25V3C14.25 2.5875 13.9125 2.25 13.5 2.25C13.0875 2.25 12.75 2.5875 12.75 3V8.25H12C11.5875 8.25 11.25 8.5875 11.25 9C11.25 9.4125 11.5875 9.75 12 9.75H15C15.4125 9.75 15.75 9.4125 15.75 9C15.75 8.5875 15.4125 8.25 15 8.25ZM7.5 12.75H8.25V15C8.25 15.4125 8.5875 15.75 9 15.75C9.4125 15.75 9.75 15.4125 9.75 15V12.75H10.5C10.9125 12.75 11.25 12.4125 11.25 12C11.25 11.5875 10.9125 11.25 10.5 11.25H7.5C7.0875 11.25 6.75 11.5875 6.75 12C6.75 12.4125 7.0875 12.75 7.5 12.75ZM9 2.25C8.5875 2.25 8.25 2.5875 8.25 3V9.75H9.75V3C9.75 2.5875 9.4125 2.25 9 2.25ZM6.75 6C6.75 5.5875 6.4125 5.25 6 5.25H5.25L5.25 3C5.25 2.5875 4.9125 2.25 4.5 2.25C4.0875 2.25 3.75 2.5875 3.75 3V5.25H3C2.5875 5.25 2.25 5.5875 2.25 6C2.25 6.4125 2.5875 6.75 3 6.75H6C6.4125 6.75 6.75 6.4125 6.75 6Z"
        fill="white"
      />
    </svg>
  );
}
